// extracted by mini-css-extract-plugin
module.exports = {"dateString":"statistics-table-component_dateString_3p3hs","totalAuthsString":"statistics-table-component_totalAuthsString_MQTvl","table":"statistics-table-component_table_3JJGh"};